import React, { useState, useContext, useRef } from 'react'
import {
   Box,
   Button,
   Card,
   CardContent,
   CardHeader,
   Divider,
   Grid,
   TextField
} from '@material-ui/core'
import { putPublicAPI } from '../../api'

// contexts
import { ToastContext } from '../../contexts/Toast'

const AccountProfileDetails = props => {
   let mounted = useRef(true)
   const { setToasts } = useContext(ToastContext)

   const [values, setValues] = useState({
      name: localStorage.user_name || '',
      email: localStorage.user_email || '',
      phone: localStorage.user_phone || '',
      company: localStorage.user_company || '',
      address: localStorage.user_address || ''
   })

   const handleChange = event => {
      mounted.current &&
         setValues({
            ...values,
            [event.target.name]: event.target.value
         })
   }

   const onSubmit = async e => {
      e.preventDefault()

      if (!values.name || !values.email || !values.phone) {
         if (!values.name) setToasts({ type: 'error', messages: [{ msg: 'Name is required' }] })

         if (!values.email)
            setToasts({ type: 'error', messages: [{ msg: 'Email address is required' }] })

         if (!values.phone)
            setToasts({ type: 'error', messages: [{ msg: 'Phone number is required' }] })

         return
      }

      let allValues = { id: localStorage.user_id, ...values }
      let updated = await putPublicAPI('/update-user', allValues)

      if (updated?.success) {
         const { fName, lName, email, address, company, phone } = updated.data

         localStorage.setItem('user_name', fName + ' ' + lName)
         localStorage.setItem('user_email', email)
         localStorage.setItem('user_phone', phone)
         localStorage.setItem('user_address', address)
         localStorage.setItem('user_company', company)

         setToasts({ type: 'success', messages: [{ msg: 'Account information updated' }] })
      } else setToasts({ type: 'error', messages: updated?.errors })
   }

   return (
      <form autoComplete='off' noValidate {...props} onSubmit={onSubmit}>
         <Card>
            <CardHeader subheader='The information can be edited' title='Profile' />
            <Divider />
            <CardContent>
               <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Name'
                        name='name'
                        onChange={handleChange}
                        required
                        value={values.name}
                        variant='outlined'
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Company'
                        name='company'
                        onChange={handleChange}
                        value={values.company}
                        variant='outlined'
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Email Address'
                        name='email'
                        onChange={handleChange}
                        required
                        disabled
                        value={values.email}
                        variant='outlined'
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Phone Number'
                        name='phone'
                        onChange={handleChange}
                        required
                        value={values.phone}
                        variant='outlined'
                     />
                  </Grid>
                  <Grid item md={12} xs={12}>
                     <TextField
                        fullWidth
                        label='Address'
                        name='address'
                        onChange={handleChange}
                        value={values.address}
                        variant='outlined'
                     />
                  </Grid>
               </Grid>
            </CardContent>
            <Divider />
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2
               }}
            >
               <Button color='primary' type='submit' variant='contained'>
                  Save details
               </Button>
            </Box>
         </Card>
      </form>
   )
}

export default AccountProfileDetails
